export type { PaginationProps } from '../../types/pagination';
export { Pagination } from './adapters/inbound/Pagination';
